import { createMetaRoute } from '@funtech-int/rival';

import { RouteMeta } from '@/shared/lib/navigation';

export const showcaseRoute = createMetaRoute<RouteMeta, { id: string }>({
    key: (params) => params.id,
});
